var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .success-1 {\n        fill: none;\n        stroke: #54A823 !important;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "053") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Essential_Form-Validation_check-circle-1",
    "data-name": "Interface-Essential / Form-Validation / check-circle-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1754",
    "data-name": "Shape 1754",
    className: "success-1",
    d: "M6,13.23,8.45,16.7a1,1,0,0,0,1.71.05L18,6.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_227",
    "data-name": "Oval 227",
    className: "success-1",
    d: "M12,23.25A11.25,11.25,0,1,0,.75,12,11.25,11.25,0,0,0,12,23.25Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.366f74b18bb47e955cfc0e3d26889399.svg";
export { ForwardRef as ReactComponent };